export default "__VITE_ASSET__B0f49jCx__"